import { gql } from '@apollo/client';

export const GET_ORGANIZATION_BILLING_INFO = gql`
  query GetOrganizationBillingInfo {
    getOrgBillingInfo {
      orgBillingInfo {
        stripe_customer_id
        stripe_subscription_id
        subscription_level
        billing_issue
        payment_status
      }
    }
  }
`;
